import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Tooltip } from 'antd';
import  { bindActionCreators } from 'redux';
import Base from '../Base';
import Certifieds from './Certifieds';
import Folders from './Folders';
import Files from './Files';
import GoogleDrive from './GoogleDrive';
import googleDrive from '../../Actions/googleDrive';
import Historical from "../Historical";
const { selectTab } = googleDrive.actions;
const { TabPane } = Tabs;

function Settings(props) {
		const { isFreePlan, tabSelected } = props;
		const goToSettingsTab = (tab) => {
			props.selectTab(tab);
		}
		
		const isCorpAccount = () => {
			const { items } = props.license;
			//get last and current package
			return items[0].nombrePaquete.toLowerCase().includes('corp');			
		}

		return(
			<Base>
				<h1 className="title-text blue-text">Configuración:</h1>
				<Tabs defaultActiveKey={tabSelected} activeKey={tabSelected}  onTabClick={goToSettingsTab} size="medium" destroyInactiveTabPane>
					<TabPane tab="Certificados" key="1"  >
						<Certifieds />
					</TabPane>
					<TabPane tab="Nombre de archivos" key="2" >
						<Files/>
					</TabPane>
					<TabPane tab="Organización de carpetas" key="3">
						<Folders/>
					</TabPane>
					<TabPane tab={
						<>
						Google drive
						{ isFreePlan && <Tooltip
										zIndex={100}
										placement="top" 							
										visible={true} 
										title="Disponible a partir del plan Base"
										color="red"/>
						}
						</>
					} key="4">
						<GoogleDrive/>
					</TabPane>
					{
						isCorpAccount() &&
						<TabPane tab="Cargar Histórico" key="5">
							<Historical/>
						</TabPane>
					}
					
				</Tabs>
			</Base>
		);
	};

const mapStateToProps = state => {	
	return {
        tabSelected: state.googleDrive.tabSelected,
		isFreePlan: state.license.isFreePlan,		
		license: state.license.licensePagination
	};
};

const mapDispatchToProps = dispatch => {    
	return {
		dispatch,
		...bindActionCreators({selectTab},dispatch)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Settings);